import * as React from "react";
import { CalendarEvent } from "source/app/presentation/MainPanel/Calendar/CalendarEventUtils/CalendarEvent";
import { BannerImages } from "source/app/services/Shared/RenderSwal/BannerImage/BannerImage";
import RenderSwal, {
    TSwalOptions,
} from "source/app/services/Shared/RenderSwal/RenderSwal";
import { ETexture } from "source/app/services/UI/Background/Texture/ETexture";
import { HSLColors } from "source/app/services/UI/Background/Texture/Helpers/HSLColor";
import { Texture } from "source/app/services/UI/Background/Texture/Texture";
import { CalendarEventEditor } from "./CalendarEventEditor";
import { UpdateCalendarEventAsync } from "./UpdateCalendarEventAsync";
import { calendarEvent_freeTime } from "motw_core/Constants/constants";
import { CreateCalendarEventAsync } from "./CreateCalendarEventAsync";

export function LaunchCalendarEventEditor(calendarEvent: CalendarEvent) {
    const swalOptions: TSwalOptions = GetSwalOptions(calendarEvent);

    const OnOKAction = calendarEvent.IsNew
        ? CreateCalendarEventAsync
        : UpdateCalendarEventAsync;

    RenderSwal(
        swalOptions,
        <CalendarEventEditor
            {...{ eventData: calendarEvent.eventData, OnOKAction }}
        />,
        OnOKAction,
        () => {}
    );
}

function GetSwalOptions(calendarEvent: CalendarEvent): TSwalOptions {
    return {
        title: calendarEvent.IsNew
            ? `Block ${calendarEvent_freeTime}`
            : `Change event "${calendarEvent.eventData.name}"`,
        bannerImage: BannerImages.target,
        background: new Texture({
            image: ETexture["dark-wood"],
            backgroundColor: HSLColors.transparent,
        }).combinedCSS.background as string,
        height: `315px`,
    };
}
